module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Clipboard-check-fb10911dbbdbafd610861434636766c7.svg";